module.exports = __webpack_public_path__ + "static/Governance.com-54497b0662bc326447dec6f9942a9ef5.jpg";